import { section } from '@/glow';

import Carousel from '@/lib/carousel';

section('featured-collection-row', {
  onLoad() {
    this.carousel = Carousel(this.container, {
      wrapAround: false,
      adaptiveHeight: false,
    });

    // Advance the slider due to inline text being hidden
    if (!window.matchMedia('(min-width: 45em)').matches) {
      this.carousel.select(1);
    }
  },

  onUnload() {
    this.carousel && this.carousel.destroy();
  },
});
